import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

console.log("map-sectioncards.js initialized");

document.addEventListener('DOMContentLoaded', function () {
    const mapContainer = document.getElementById('map');
    
    if (!mapContainer) {
        console.warn('No map container found');
        return;
    }

    // Get access token from data attribute
    const accessToken = mapContainer.dataset.accessToken;
    
    if (!accessToken) {
        console.error('No access token found for Mapbox');
        return;
    }

    mapboxgl.accessToken = accessToken;

    // Gather markers from .card-item elements
    function gatherMarkers() {
        const points = [];
        const cards = document.querySelectorAll('.card-item');
        
        cards.forEach(card => {
            const lat = parseFloat(card.dataset.lat);
            const lng = parseFloat(card.dataset.lon);
            
            if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
                points.push({
                    lat,
                    lng,
                    name: card.dataset.name || 'Sin nombre',
                    slug: card.dataset.slug || ''
                });
            }
        });
        
        return points;
    }

    const markersData = gatherMarkers();
    console.log('Markers found:', markersData.length);

    if (markersData.length === 0) {
        mapContainer.innerHTML = '<p class="text-center p-5">No hay localizaciones disponibles</p>';
        return;
    }

    // Initialize map
    const mapInstance = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [markersData[0].lng, markersData[0].lat],
        zoom: markersData.length === 1 ? 14 : 10
    });

    mapInstance.on('load', function () {
        const bounds = new mapboxgl.LngLatBounds();

        markersData.forEach(item => {
            bounds.extend([item.lng, item.lat]);

            const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(
                `<strong>${item.name}</strong>`
            );

            new mapboxgl.Marker({ color: '#3b82f6' })
                .setLngLat([item.lng, item.lat])
                .setPopup(popup)
                .addTo(mapInstance);
        });

        // Fit bounds with padding
        if (markersData.length > 1 && !bounds.isEmpty()) {
            mapInstance.fitBounds(bounds, { 
                padding: 50, 
                maxZoom: 15, 
                duration: 1000 
            });
        }
        
        console.log('Map initialized successfully');
    });
});

